module.exports = __webpack_public_path__ + "img/KR_B.b82dfe36.png";